// __webpack_public_path__ = window.CDN_HOST || "/assets/";

const Main = require('./thankyou/index');
module.exports = {};
